<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <custom-popup v-model="dialog" :cons="{ title: 'انتخاب پترن/کمپین' }">
        <template v-slot:activator>
          <div class="rowinfo">
            <v-btn
              :class="!!value ? 'btn-edit' : 'btn-refund'"
              :loading="loading"
              class="ma-0"
              style="letter-spacing: normal"
            >
              <v-icon class="me-2">mdi-plus</v-icon>
              <span v-if="!!value">تغییر پترن/کمپین</span>
              <span v-else>انتخاب پترن/کمپین</span>
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-computedValue-text`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="!!value ? 'تغییر پترن/کمپین' : 'انتخاب پترن/کمپین'"
            />
          </div>
        </template>

        <v-card :loading="loading" class="pa-4" flat>
          <v-card-title class="pa-2">
            <div class="rowinfo">
              <v-btn
                class="btn-refund contentinfo pl-2"
                :href="`${$corepayamakApi}/#/text`"
                target="_blank"
              >
                <v-icon class="me-2">mdi-plus</v-icon>
                ثبت پترن جدید
              </v-btn>
              <help-info
                :element-name="`${serviceName}-${componentName}-computedValue-text`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="ثبت پترن جدید"
              />
            </div>
            <div class="rowinfo">
              <v-btn
                class="btn-send-sms contentinfo pl-2"
                :href="`${$corepayamakApi}/#/campaign`"
                target="_blank"
              >
                <v-icon class="me-2">mdi-plus</v-icon>
                ثبت کمپین جدید
              </v-btn>
              <help-info
                :element-name="`${serviceName}-${componentName}-computedValue-text`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="ثبت کمپین جدید"
              />
            </div>
          </v-card-title>

          <custom-tabs v-model="tabs" :tab-items="tabItems" grow>
            <template v-slot:helpinfo="{ tab }">
              <help-info
                v-if="tab && tab.value && tab.text"
                :element-name="`${serviceName}-${componentName}-data-${tab.value}`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="`${tab.text}`"
              />
            </template>
            <template v-slot:staticItems>
              <!-- 0: انتخاب پترن من -->
              <v-tab-item class="py-4">
                <data-table
                  :columns="columns"
                  :data="data"
                  :per-page="[10, 25, 50, 100, 400]"
                  :translate="translate"
                  @row-clicked="selectRow"
                  @on-table-props-changed="reloadTable"
                />

                <v-card
                  v-if="(!data.data || !data.data.length) && !loading"
                  class="text-muted text-center font-size-h3 d-flex align-center justify-center"
                  flat
                  height="200"
                >
                  الگویی پیدا نشد، ابتدا یک الگو ثبت فرمایید.
                </v-card>
              </v-tab-item>

              <!-- 1: انتخاب کمپین من -->
              <v-tab-item class="py-4">
                <message-list ref="message-list-user" :camp-id.sync="campId" api-type="user" />
              </v-tab-item>

              <!-- 2: انتخاب پترن عمومی -->
              <v-tab-item class="py-4">
                <data-table
                  :columns="columns"
                  :data="data"
                  :per-page="[10, 25, 50, 100, 400]"
                  :translate="translate"
                  @row-clicked="selectRow"
                  @on-table-props-changed="reloadTable"
                />

                <v-card
                  v-if="(!data.data || !data.data.length) && !loading"
                  class="text-muted text-center font-size-h3 d-flex align-center justify-center"
                  flat
                  height="200"
                >
                  الگویی پیدا نشد.
                </v-card>
              </v-tab-item>

              <!-- 3: انتخاب کمپین عمومی -->
              <v-tab-item class="py-4">
                <message-list ref="message-list-public" :camp-id.sync="campId" api-type="public" />
              </v-tab-item>
            </template>
          </custom-tabs>
        </v-card>
      </custom-popup>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../pages/qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../pages/qrland/components/helpAcordion/HelpInfoWrapper.vue";
import MessageList from "@/view/components/fragments/messageList.vue";
import { SmsAxios } from "@/main";

export default {
  name: "smsPatternPicker",

  components: { MessageList, HelpInfo, HelpInfoWrapper },

  props: {
    value: Object,
    rerender: Boolean,
    text: Array,
  },

  data: () => ({
    tabItems: [
      {
        text: "انتخاب پترن من",
        value: "select_pattern_user",
        icon: "mdi-card-account-details-outline",
      },
      {
        text: "انتخاب کمپین من",
        value: "select_campaign_user",
        icon: "mdi-bullhorn-outline",
      },
      {
        text: "انتخاب پترن عمومی",
        value: "select_pattern_public",
        icon: "mdi-card-account-details-star-outline",
      },
      {
        text: "انتخاب کمپین عمومی",
        value: "select_campaign_public",
        icon: "mdi-bullhorn-variant-outline",
      },
    ],
    helpData: [],
    serviceName: "Qrland",
    componentName: "smspatternpicker",
    data: {},
    dialog: false,
    columns: [
      {
        label: "شناسه",
        name: "id",
        orderable: true,
      },
      {
        label: "نوع",
        name: "type",
        orderable: true,
        transform: ({ data }) => {
          return data.type === "pattern" ? "پترن" : "ثابت";
        },
      },
      {
        label: "عنوان",
        name: "title",
        orderable: true,
      },
      {
        label: "متن",
        name: "content",
        transform: ({ data }) => {
          return data.content.substr(0, 70) + "...";
        },
        orderable: true,
      },
      {
        label: "وضعیت",
        name: "active",
        transform: ({ data }) => {
          return data.active === 0
            ? `<p class="badge badge-danger">رد شده</p>`
            : `<p class="badge badge-success">تایید شده</p>`;
        },
        orderable: true,
      },
    ],
    translate: {
      nextButton: "بعدی",
      previousButton: "قبلی",
      rowsPerPageText: "تعداد در صفحه",
      noDataText: "داده ای برای نمایش وجود ندارد",
      placeholderSearch: "جستجو",
    },
    tableProps: {
      search: "",
      length: 10,
      column: "id",
      dir: "desc",
      active: 1,
      Uid: undefined,
    },
    tabs: 0,
    patternLoading: false,
    loading: false,
    mlModel: [],
    campId: null,
    selectedRow: null,
  }),

  mounted() {
    setTimeout(() => {
      this.getDefaultPattern();
    }, 500);
  },

  computed: {
    computedValue: {
      get() {
        return this.selectedRow;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    dialog(val) {
      if (val) this.getData();
    },
    campId(val) {
      this.selectCamp(val);
    },
    tabs(val) {
      if (val === 0 || val === 2) {
        this.tableProps.search = ""; 
        this.getData();
      }
    }
  },

  methods: {
    async getData(query = this.tableProps) {
      this.search = query.search;
      this.loading = true;

      const apiPath = this.tabs === 2 ? "text/public" : "text/user";

      await SmsAxios.get(apiPath, {
        params: {
          ...query,
          active: 1,
        },
      })
        .then(({ data }) => {
          this.data = data;
        })
        .finally(() => (this.loading = false));
    },
    selectRow(data) {
      const id = data.id;

      $("tr").css("background", "");

      $(`tr:contains("${id}")`).each(function (index, item) {
        if ($(item).find("td").eq(0).text() === id)
          $(item).css("background", "rgba(99, 0, 244, 0.28)");
      });

      this.computedValue = data;
      this.dialog = false;
    },
    selectCamp(data) {
      const refName = this.tabs === 3 ? "message-list-public" : "message-list-user";
      const obj = this.$refs[refName]?.data?.data.find(
        (item) => item.id === data
      );
      
      if (!obj) return;
      delete obj.id;

      this.computedValue = {
        ...obj,
        campId: data,
      };
      this.dialog = false;
    },
    reloadTable(tableProps) {
      this.tableProps = tableProps;
      this.getData(tableProps);
    },
    getDefaultPattern() {
      this.getData({ ...this.tableProps, Uid: this.value?.id }).then(() => {
        this.$emit("reload", false);

        setTimeout(() => {
          this.computedValue = this.data?.data?.find(
            (item) => item.id == this.value.id
          );
          this.$nextTick(() => {
            this.$emit("reload", true);
            this.$forceUpdate();
          });
        }, 1000);
      });
    },
  },
};
</script>

<style scoped></style>
